import {
  UI_FOCUSED_TYPE_BLOG,
  UI_FOCUSED_TYPE_BRAND,
  UI_FOCUSED_TYPE_CATEGORY, UI_FOCUSED_TYPE_OTHER, UI_FOCUSED_TYPE_PAGE,
  UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN,
  UI_FOCUSED_TYPE_PRODUCT_DETAIL
} from "../dynamicUi/constants";


export const FOCUS_DISPLAY_TYPE_GRID = "GRID";
export const FOCUS_DISPLAY_TYPE_LIST = "LIST";
export const FOCUS_DISPLAY_TYPE_PRODUCT_VIEW = "PRODUCT_VIEW";
export const FOCUS_DISPLAY_TYPE_CUSTOM = "CUSTOM";


export const FOCUS_DISPLAY_TYPE = [
  { value: FOCUS_DISPLAY_TYPE_GRID, label: 'Grid' },
  { value: FOCUS_DISPLAY_TYPE_LIST, label: 'List' },
  { value: FOCUS_DISPLAY_TYPE_PRODUCT_VIEW, label: 'Product View' },
  { value: FOCUS_DISPLAY_TYPE_CUSTOM, label: 'Customize' },
];


//do not change the order
export const FOCUS_ARROW_HIDDEN_TYPE = [
  { value: 'Side', label: 'Side' },
  { value: 'Overlap', label: 'Overlap' },
  { value: 'Hidden', label: 'Hidden' },


];

export const FOCUS_TYPE_OPTIONS = [
  { value: UI_FOCUSED_TYPE_BRAND, label: 'Brand', icon: 'local_offer' },
  { value: UI_FOCUSED_TYPE_CATEGORY, label: 'Category', icon: 'grid_view' },
  { value: UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN, label: 'Product Campaign', icon: 'campaign' },
  { value: UI_FOCUSED_TYPE_PRODUCT_DETAIL, label: 'Product Detail', icon: 'inventory' },
  { value: UI_FOCUSED_TYPE_PAGE, label: 'Dynamic Pages', icon: 'article' },
  { value: UI_FOCUSED_TYPE_BLOG, label: 'Blogs', icon: 'article' },
  { value: UI_FOCUSED_TYPE_OTHER, label: 'Others', icon: 'add_link' },
];

export const PRODUCT_CAMPAIGN_NAMES = { productCampaignNormal: 'normal', productCampaignDiscounted: 'discount' };
export const FOCUSED_ITEMS_OTHERS_TYPE = { noLink: 'noLink', anyLink: 'anyLink', copy: 'copy' };

export const PRODUCT_CAMPAIGN_TYPE = [
  { value: PRODUCT_CAMPAIGN_NAMES.productCampaignNormal, label: "Normal" },
  { value: PRODUCT_CAMPAIGN_NAMES.productCampaignDiscounted, label: "Discount" }
];

export const FOCUSED_ITEMS_OTHERS_LIST = [
  { value: FOCUSED_ITEMS_OTHERS_TYPE.noLink, label: "Do Nothing" },
  { value: FOCUSED_ITEMS_OTHERS_TYPE.anyLink, label: "Any Link" },
  { value: FOCUSED_ITEMS_OTHERS_TYPE.copy, label: "Copy Text" },
];

export const LOCATION_TYPE = [
  {
    value: 'PROVINCE', label: 'Province'
  },
  {
    value: 'CITY', label: 'City'
  },
  {
    value: 'AREA', label: 'Area'
  }
];
export const FOCUS_ITEM_STYLE = { normal: 'normal', banner: 'banner', horizontal: 'horizontal' };
export const FOCUS_ITEM_STYLE_LIST = [
  {
    value: FOCUS_ITEM_STYLE.normal,
    label: 'Normal'
  }, {
    value: FOCUS_ITEM_STYLE.banner, label: 'Banner'
  }, {
    value: FOCUS_ITEM_STYLE.horizontal, label: 'Horizontal List'
  }];

export var FOCUSED_HORIZONTAL_OPTIMAL_HEIGHT = 150;

export const MIN_BANNER_ITEMS = 2;
export const MIN_HORIZONTAL_ITEMS = 5;


export const ACTIVE = "ACTIVE";
export const INACTIVE = "INACTIVE";

export const FOCUS_ITEMS_TABS = [
  { value: ACTIVE, label: 'Active' },
  { value: INACTIVE, label: 'Inactive' },
]
